import { Badge } from '@material-ui/core'
import React from 'react'
import styled from 'styled-components'

import PrescribeIconSvg from '../../img/prescribe-icon.inline.svg'

const StyledPrescribeIconSvg = styled(PrescribeIconSvg)`
  display: inline-block;
  height: 100%;
  width: auto;
  object-fit: contain;
  margin-right: 15px;
  fill: currentColor;
  cursor: pointer;
`

const StyledBadge = styled(Badge)`
  & .MuiBadge-badge {
    right: 10px;
    top: 10px;
    transform: scale(0.85) translate(50%, -50%);
    z-index: 0;
  }

  transition: transform 200ms ease-in-out;

  &:hover {
    transform: scale(1.08);
  }
`

export const PrescriptionIcon: React.FC<{
  count: number
}> = ({ count }) => {
  return (
    <StyledBadge badgeContent={count} color="primary" invisible={count === 0}>
      <StyledPrescribeIconSvg />
    </StyledBadge>
  )
}
